import React, { useRef } from 'react';
import { Dropdown } from 'react-bootstrap';

const DropDownsCol = ({ cols, toggleCheck }) => {
    const checkboxRef = useRef(null);

    const ChildComponent = React.forwardRef((props, ref) => {
        return (
            <div>
                <input type="checkbox" readOnly className="form-check-input" ref={ref} checked={props.estado} />
                <label className="text-capitalize">{props.texto}</label>
            </div>
        );
    });
    return (
        <Dropdown>
            <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                <i className="mdi  mdi-table-headers-eye mdi-18px "></i>
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {Object.keys(cols).map((columnName, i) => (
                    <Dropdown.Item key={`sh${i}`} onClick={() => toggleCheck(columnName)}>
                        <ChildComponent
                            ref={checkboxRef}
                            texto={cols[columnName].texto}
                            estado={cols[columnName].estado}
                        />
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default DropDownsCol;
